import { memoryStorage } from "./memoryStorage";

export const ADMIN_USERS_STORAGE_KEY = "blackroth_admin_users";

export const DEFAULT_ADMINS = [
  {
    id: 1,
    name: "Super Admin",
    email: "admin1@mail.com",
    role: "SUPER_ADMIN",
    password: "Admin@123",
    permissions: ["ALL_ACCESS"],
  },
  {
    id: 2,
    name: "System Admin",
    email: "admin2@mail.com",
    role: "HR_ADMIN",
    password: "Admin@123",
    permissions: ["VIEW_JOBS", "MANAGE_APPLICATIONS"],
  },
];

const sanitizeAdmin = (admin, index) => ({
  id: admin?.id ?? index + 1,
  name: admin?.name ?? "",
  email: admin?.email ?? "",
  role: admin?.role ?? "",
  password: admin?.password ?? "",
  permissions: Array.isArray(admin?.permissions) ? admin.permissions : [],
});

const cloneDefaults = () => DEFAULT_ADMINS.map((admin) => ({ ...admin }));

export const loadAdminUsers = () => {
  try {
    const raw = memoryStorage.getItem(ADMIN_USERS_STORAGE_KEY);
    if (!raw) {
      return cloneDefaults();
    }

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return cloneDefaults();
    }

    return parsed.map(sanitizeAdmin);
  } catch (error) {
    return cloneDefaults();
  }
};

export const saveAdminUsers = (admins) => {
  memoryStorage.setItem(ADMIN_USERS_STORAGE_KEY, JSON.stringify(admins));
};
 